<dx-popup
    class="popup"
    [width]="isPhone ? 300 : 480"
    [height]="isPhone ? 220 : 200"
    [showTitle]="false"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="popupVisible"
>
    <div *dxTemplate="let data of 'content'">
        <p style="margin-bottom: 2em !important;" fxShow fxHide.xs>The standing order was {{mode === 'create' ? 'created' : 'updated'}} successfully, what do you like to do next?</p>
        <p fxShow fxHide.gt-xs>The standing order was {{mode === 'create' ? 'created' : 'updated'}}</p>
        <p style="margin-bottom: 2em !important;" fxShow fxHide.gt-xs> successfully, what do you like to do next?</p>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <p>New Standing Order Same Patient</p>
            <dx-button [text]="'New'" (click)="redirectToNewWithPatient()" height="26px" width="60px"></dx-button>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <p>New Standing Order Different Patient</p>
            <dx-button [text]="'New'" (click)="redirectToNew()" height="26px" width="60px"></dx-button>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <p>Standing Order Search</p>
            <dx-button [text]="'Search'" (click)="redirectToSearch()" height="26px" width="60px"></dx-button>
        </div>
    </div>

</dx-popup>
